import "./Packages.css";
import { Button, Dropdown } from "react-bootstrap";
import React, { useState } from "react";

const Packages = ({ formData, setFormData }) => {
  const [basicUKPrice, setBasicUKPrice] = useState(
    formData.paymentPackage.quantity * 5
  );
  const [mixedEUPrice, setMixedEUPrice] = useState(
    formData.paymentPackage.quantity * 8.5
  );
  const [selectedQuantity, setSelectedQuantity] = useState(
    formData.paymentPackage.quantity
  );

  const handleQuantitySelect = (pack, quantity) => {
    setSelectedQuantity(quantity);

    if (pack === "BasicUK") {
      setBasicUKPrice(quantity * 5);

      setFormData((prev) => ({
        ...prev,
        paymentPackage: {
          ...prev.paymentPackage,
          packageName: "BasicUK",
          price: quantity * 5,
          quantity: quantity,
        },
      }));
    } else {
      setMixedEUPrice(quantity * 8.5);

      setFormData((prev) => ({
        ...prev,
        paymentPackage: {
          ...prev.paymentPackage,
          packageName: "MixedEU",
          price: quantity * 8.5,
          quantity: quantity,
        },
      }));
    }
  };

  const handlePackageChange = (pack) => {
    if (pack === "BasicUK") {
      setBasicUKPrice(selectedQuantity * 5);

      setFormData((prev) => ({
        ...prev,
        paymentPackage: {
          ...prev.paymentPackage,
          packageName: "BasicUK",
          price: selectedQuantity * 5,
          quantity: selectedQuantity,
        },
      }));
      window.open("https://buy.stripe.com/28o5lb2Yt2Vg3GofYY", "_blank");
    } else {
      setMixedEUPrice(selectedQuantity * 8.5);

      setFormData((prev) => ({
        ...prev,
        paymentPackage: {
          ...prev.paymentPackage,
          packageName: "MixedEU",
          price: selectedQuantity * 8.5,
          quantity: selectedQuantity,
        },
      }));
      window.open("https://buy.stripe.com/bIYdRH6aF0N80uc001", "_blank");
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="simCard">
        <p className="title">Basic UK Sims</p>
        <p className="price">${basicUKPrice}</p>
        <p className="desc">Per Line Per Month</p>
        <Dropdown>
          <Dropdown.Toggle className="mb-4" id="dropdown-basic">
            {selectedQuantity ? `Quantity: ${selectedQuantity}` : "Quantity"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("BasicUK", "1");
              }}
            >
              1 Number
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("BasicUK", "2");
              }}
            >
              2 Numbers
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("BasicUK", "3");
              }}
            >
              3 Number
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button
          className={
            formData.paymentPackage.packageName === "BasicUK" && "primaryBtn"
          }
          onClick={() => {
            handlePackageChange("BasicUK");
          }}
          type="button"
          variant={
            formData.paymentPackage.packageName !== "BasicUK" && "secondary"
          }
        >
          {formData.paymentPackage.packageName === "BasicUK"
            ? "Enabled"
            : "Enable"}
        </Button>
      </div>
      <div className="simCard">
        <p className="title">Mixed EU Sims</p>
        <p className="price">${mixedEUPrice}</p>
        <p className="desc">Per Line Per Month</p>
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic" className="mb-4">
            {selectedQuantity ? `Quantity: ${selectedQuantity}` : "Quantity"}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("MixedEU", "1");
              }}
            >
              1 Number
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("MixedEU", "2");
              }}
            >
              2 Numbers
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                handleQuantitySelect("MixedEU", "3");
              }}
            >
              3 Number
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Button
          className={
            formData.paymentPackage.packageName === "MixedEU" && "primaryBtn"
          }
          onClick={() => {
            handlePackageChange("MixedEU");
          }}
          type="button"
          variant={
            formData.paymentPackage.packageName !== "MixedEU" && "secondary"
          }
        >
          {formData.paymentPackage.packageName === "MixedEU"
            ? "Enabled"
            : "Enable"}
        </Button>
      </div>
    </div>
  );
};

export default Packages;
